import { render, staticRenderFns } from "./translationsEvent.vue?vue&type=template&id=747f516f&"
import script from "./translationsEvent.vue?vue&type=script&lang=js&"
export * from "./translationsEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports